var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poolicon"},[_c('div',{staticClass:"lettercontainer"},[_c('div',{staticClass:"lettertext"},[_vm._v(" "+_vm._s(_vm.letter)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }